import React from 'react'

const Pagenation = ({ page, setPage, totalPages }) => {
	return (
		<div>
			<div className='pagination-container mt-3 mb-3'>
				<ul className='pagination pagination-dark justify-content-end'>
					<li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
						<button className='page-link' onClick={() => setPage(page - 1)} disabled={page === 1}>
							<span className='material-icons'>arrow_back</span>
						</button>
					</li>

					{[...Array(totalPages)].map((_, index) => (
						<li key={index} className={`page-item ${page === index + 1 ? 'active' : ''}`}>
							<button className='page-link' onClick={() => setPage(index + 1)}>
								{index + 1}
							</button>
						</li>
					))}

					<li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
						<button className='page-link' onClick={() => setPage(page + 1)} disabled={page === totalPages}>
							<span className='material-icons'>arrow_forward</span>
						</button>
					</li>
				</ul>
			</div>
		</div>
	)
}

export default Pagenation
